module.exports = __webpack_public_path__ + "img/btn_try_again.5150769d.png";